<div class="mts-overlay bs-enabled animated fadeIn" (click)="onClose.emit()">
    <div class="mts-panel animated slideInDown" (click)="$event.stopPropagation()">

        <!-- Panel header -->
        <div class="mts-panel-header flex-row align-items-center justify-content-between">
            <div class="flex-row gap-2 align-items-center">
                <i class="far fa-users" style="color: #333;"></i>
                <span class="fw-500" style="font-size: 14px; letter-spacing: 0.3px; color: #333;">Switch Tenant</span>
            </div>
            <i class="zmdi zmdi-close cursor-pointer hvr-opacity" style="font-size: 1.35rem; color: #555;" (click)="onClose.emit()"></i>
        </div>

        <!-- Search -->
        <div style="padding: 12px 14px 8px;">
            <div class="search-box flxRow" style="position: relative;">
                <i class="zmdi zmdi-search" style="position: absolute; left: 8px; top: 50%; transform: translateY(-50%); font-size: 19px; color: #bbb; pointer-events: none;"></i>
                <input type="search"
                       [(ngModel)]="searchTxt"
                       [maxlength]="dic.CONSTANTS.maxCharsInSearch"
                       (input)="applyFiltersAndSort()"
                       placeholder="Search by domain or company name"
                       style="flex: 1 0; padding-left: 30px;">
                <a class="closeRed animated fadeIn"
                   *ngIf="searchTxt"
                   (click)="searchTxt = ''; applyFiltersAndSort();"
                   style="font-size: 15px; color: #bbb; position: absolute; right: 12px; top: 50%; transform: translateY(-50%);">
                    <i class="zmdi zmdi-close"></i>
                </a>
            </div>
        </div>

        <!-- Filters -->
        <div class="mts-filters-section">
            <!-- Plan type chips -->
            <div class="flex-row gap-1 align-items-center flex-wrap justify-content-start" style="margin-bottom: 7px;">
                <span class="mts-section-micro-label">Plan type:</span>
                <span class="mts-filter-chip" [ngClass]="{'active': !planTypeFilter}" (click)="setPlanTypeFilter('')">All</span>
                <span class="mts-filter-chip" [ngClass]="{'active': planTypeFilter === dic.CONSTANTS.planSubType.annual}" (click)="setPlanTypeFilter(dic.CONSTANTS.planSubType.annual)">Annual</span>
                <span class="mts-filter-chip" [ngClass]="{'active': planTypeFilter === dic.CONSTANTS.planSubType.msp}" (click)="setPlanTypeFilter(dic.CONSTANTS.planSubType.msp)">Monthly</span>
                <span class="mts-filter-chip" [ngClass]="{'active': planTypeFilter === dic.CONSTANTS.planSubType.poc}" (click)="setPlanTypeFilter(dic.CONSTANTS.planSubType.poc)">PoC</span>
                <span class="mts-filter-chip" [ngClass]="{'active': planTypeFilter === 'template'}" (click)="setPlanTypeFilter('template')">Template</span>
            </div>
            <!-- Toggle filters -->
            <div class="flex-row gap-2 align-items-center flex-wrap justify-content-start">
                <span class="mts-filter-toggle" *ngIf="gs.reviewerInfo?.is_security_reviewer" [ngClass]="{'active': showSilentModeOnly}" (click)="showSilentModeOnly = !showSilentModeOnly; applyFiltersAndSort()">
                    <i class="far fa-volume-mute" style="font-size: 10px;"></i> EMDR Silent Mode
                </span>
            </div>
        </div>

        <!-- List -->
        <div class="mts-list-container">

            <!-- Empty state -->
            <div *ngIf="!favoriteAdmins.length && !regularAdmins.length" class="flex-column centralize" style="height: 90px;">
                <i class="fas fa-search text-muted" style="font-size: 1.3rem; opacity: 0.3; margin-bottom: 6px;"></i>
                <span class="text-muted" style="font-size: 12px;">No tenants match your search</span>
            </div>

            <!-- Favorites section -->
            <ng-container *ngIf="favoriteAdmins.length">
                <div class="mts-section-label">
                    <i class="far fa-star" style="color: #f5a623; font-size: 10px;"></i>
                    Favorites
                    <span class="mts-count-badge">{{favoriteAdmins.length}}</span>
                </div>
                <virtual-scroller class="f-1-0"
                                  style="overflow: hidden;"
                                  [style.height]="favoriteAdmins.length * 54 + 'px'"
                                  #favScroll
                                  [items]="favoriteAdmins"
                                  [enableUnequalChildrenSizes]="true">
                    <div class="mts-admin-item"
                         *ngFor="let admin of favScroll.viewPortItems"
                         [ngClass]="{'is-active-admin': gs.controlAdmin?.email === admin.email}"
                         (click)="selectAdmin(admin)">
                        <ng-container *ngTemplateOutlet="adminItemTpl; context: {admin: admin}"></ng-container>
                    </div>
                </virtual-scroller>
                <div class="mts-section-divider" *ngIf="regularAdmins.length"></div>
            </ng-container>

            <!-- All / regular tenants section -->
            <ng-container *ngIf="regularAdmins.length">
                <div class="mts-section-label" *ngIf="favoriteAdmins.length">
                    All Tenants
                    <span class="mts-count-badge">{{regularAdmins.length}}</span>
                </div>
                <virtual-scroller class="f-1-0"
                                  style="overflow: hidden;"
                                  [style.height]="regularAdmins.length * 54 + 'px'"
                                  #allScroll
                                  [items]="regularAdmins"
                                  [enableUnequalChildrenSizes]="true">
                    <div class="mts-admin-item"
                         *ngFor="let admin of allScroll.viewPortItems"
                         [ngClass]="{'is-active-admin': gs.controlAdmin?.email === admin.email}"
                         (click)="selectAdmin(admin)">
                        <ng-container *ngTemplateOutlet="adminItemTpl; context: {admin: admin}"></ng-container>
                    </div>
                </virtual-scroller>
            </ng-container>

        </div>
    </div>
</div>

<!-- Admin row template -->
<ng-template #adminItemTpl let-admin="admin">
    <!-- Plan type icon -->
    <div class="mts-type-icon-wrap">
        <i *ngIf="admin.isTemplate" class="far fa-clipboard-list text-muted" tooltip="Template plan"></i>
        <ng-container *ngIf="!admin.isTemplate">
            <i class="far"
               [title]="gs.reviewerInfo?.is_security_reviewer && admin.alloc_plan_id?.plan_sub_type === dic.CONSTANTS.planSubType.poc ? 'POC' : 'Plan'"
               [ngClass]="gs.reviewerInfo?.is_security_reviewer && admin.alloc_plan_id?.plan_sub_type === dic.CONSTANTS.planSubType.poc ? 'fa-user-cog' : 'fa-user-tie'"></i>
            <i title="EMDR Silent Mode"
               *ngIf="gs.reviewerInfo?.is_security_reviewer && admin.alloc_plan_id?.emdr?.is_silent_mode"
               class="far fa-volume-mute mts-silent-badge"></i>
        </ng-container>
    </div>

    <!-- Email + company -->
    <div class="flex-column f-1-0 ellipsis" style="gap: 2px;">
        <div class="flex-row align-items-center gap-2 ellipsis">
            <span class="ellipsis" style="font-size: 13px; font-weight: 500;">{{admin.company_name || admin.display_email}}</span>
			<div class="f-1-0"></div><!--padder-->
            <span *ngIf="gs.planAdmins[0]?.email === admin.email" class="mts-you-tag">you</span>
        </div>
        <span class="ellipsis text-muted" style="font-size: 11px;" *ngIf="admin.company_name && admin.company_name !== admin.display_email">{{admin.display_email}}</span>
    </div>

    <!-- Star button -->
    <i class="far fa-star mts-star-btn"
       [ngClass]="{'is-favorite': admin.isFavourite}"
       (click)="toggleFavorite(admin, $event)"
       [tooltip]="admin.isFavourite ? 'Remove from favorites' : 'Add to favorites'"
       placement="left"></i>
</ng-template>
